import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { headerLabel } from "assets/properties/properties";
import { useNavigate } from "react-router-dom";
import { parseResponseData } from "utils/Utils";
import { colateralApprovalData } from "assets/properties/properties";

const CollateralApproval = ({ seletedBranchCode }) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const [status, setStatus] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  useEffect(() => {
    GetData();
  }, []);

  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.COLLATERAL_APPROVAL_SEARCH + "?status=ENTERED",
      authToken: authToken,
      method: "GET",
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      const parseData = parseResponseData(result?.data);
      if (!parseData?.length) {
        toastUpdate("Error", "No Data Found", true);
        return;
      }
      parseIndicatorData(parseData);
    }
  };

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data?.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((ForApprovalApplication, index) => {
        let row = {
          id: ForApprovalApplication?.id,
          leadId: ForApprovalApplication?.loanApplicationId,
          sender: ForApprovalApplication?.makerUsername,
          loanAccountNumber: ForApprovalApplication?.loanAccountNumber,
          customerId: ForApprovalApplication?.customerId,
          branchCode: ForApprovalApplication?.branchCode,
          discrepancy: parseResponseData(
            ForApprovalApplication?.discrepencyLoans
          ),
          status: ForApprovalApplication?.status,
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onClickUpdateData = async (loanApplicationId, collaterDiscId) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
    setStatus(colateralApprovalData?.statusCode);
    const navigationData = {
      loanApplicationId,
      status: colateralApprovalData?.statusCode,
      editable: false,
      seletedBranchCode,
      collaterDiscId,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label={headerLabel?.collateralDicrepancyApproval}
          onlyLabel
        />
      </Grid>

      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={colateralApprovalData?.tableColumns}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="collateralApproval"
        />
      </Grid>
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
    </Grid>
  );
};

CollateralApproval.propTypes = {
  classes: PropTypes.object,
};

export default CollateralApproval;
